<div
  class="row bom-accordion"
  tabindex="0"
  (click)="onToggleExpand()"
  (keydown.enter)="onToggleExpand()"
>
  <div class="col col-auto">
    <ng-container *ngIf="expanded; else chevronRight">
      <ng-container *ngTemplateOutlet="arrowDown"></ng-container>
    </ng-container>
  </div>
  <div class="col">
    <h4 class="mt-0">{{ title }}</h4>
  </div>
  <ng-container *ngIf="badge">
    <div class="col col-auto">
      <bom-badge [type]="badge.type" [text]="badge.text"></bom-badge>
    </div>
  </ng-container>
  <ng-container *ngIf="progressText">
    <div class="col col-auto p-2 ml-2 right">
      {{ progressText }}
    </div>
  </ng-container>
</div>
<ng-container *ngIf="expanded">
  <div>
    <ng-content></ng-content>
  </div>
</ng-container>

<ng-template #chevronRight>
  <svg class="icon-svg">
    <use xlink:href="#chevron-right"></use>
  </svg>
</ng-template>
<ng-template #arrowDown>
  <svg class="icon-svg">
    <use xlink:href="#angle-arrow-down"></use>
  </svg>
</ng-template>
